// @ts-nocheck
(() => {
  'use strict';

  if (window.__productCardV2Loaded) return;
  window.__productCardV2Loaded = true;

  const T = (window.Theme && window.Theme.translations) || {};
  const L = {
    soldOut: T.sold_out || 'Out of Stock',
    bisNotify: T.back_in_stock_notify || 'Notify me',
    addToCart: T.add_to_cart || 'Add to cart',
    added: T.added || 'Added',
    moreDetails: T.more_details || 'More details',
  };

  const BADGES = {
    'new':                 { text: 'NEW', bg: 'linear-gradient(90deg, #F51C82 0%, #F05223 100%)', color: '#fff' },
    'rx':                  { text: 'RX', bg: '#18369C', color: '#fff' },
    'out-of-stock':        { text: 'OUT OF STOCK', bg: '#232B38', color: '#fff' },
    'limited':             { text: 'LIMITED EDITION', bg: 'linear-gradient(283deg, #DAAF2C 7.7%, #8F6820 112.45%)', color: '#fff' },
    'discontinued':        { text: 'DISCONTINUED', bg: '#969CA5', color: '#fff' },
    'signature-series':    { text: 'SIGNATURE SERIES', bg: 'linear-gradient(283deg, #18369C 9.24%, #31C3E8 143.16%)', color: '#fff' },
    'polarized':           { text: 'POLARIZED', bg: '#FFF', color: '#232B38' },
    'blue-light':          { text: 'BLUE LIGHT', bg: '#08B1FF', color: '#fff' },
    'readers':             { text: 'READERS', bg: '#08B1FF', color: '#fff' },
    'pure-blend-polarized':{ icon: true, bg: '#1B1A1A', border: '' },
    'pureblend':           { icon: true, bg: '#1B1A1A', border: '' },
    'prime-black':         { icon: true, bg: '#FFF', border: '0.5px solid #EFEFEF' },
    'prime-gold':          { icon: true, bg: '#FFF', border: '0.5px solid #EFEFEF' },
    'float':               { icon: true, bg: '#FFF', border: '0.5px solid #EFEFEF' },
    'pre-order':           { text: 'PRE ORDER', bg: '#0078D4', color: '#fff' },
  };

  const ATC_CHECK_SVG = '<svg width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" style="--icon-stroke-width:2px"><path d="M4.75439 10.7485L7.68601 14.5888C7.79288 14.7288 7.84632 14.7988 7.91174 14.8242C7.96907 14.8466 8.03262 14.8469 8.09022 14.8253C8.15596 14.8007 8.21026 14.7314 8.31886 14.5927L15.2475 5.74658" stroke="currentColor" stroke-width="var(--icon-stroke-width)" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  const STAR_PATH = '<path d="M31.547 12a.848.848 0 00-.677-.577l-9.427-1.376-4.224-8.532a.847.847 0 00-1.516 0l-4.218 8.534-9.427 1.355a.847.847 0 00-.467 1.467l6.823 6.664-1.612 9.375a.847.847 0 001.23.893l8.428-4.434 8.432 4.432a.847.847 0 001.229-.894l-1.615-9.373 6.822-6.665a.845.845 0 00.214-.869z"/>';

  const formatMoney = (cents) => {
    const format = (window.Shopify && window.Shopify.money_format) || '${{amount}}';
    const amount = (cents / 100).toFixed(2);
    const noDec = Math.floor(cents / 100).toString();
    const sep = (s, c) => s.replace(/\B(?=(\d{3})+(?!\d))/g, c);
    const withCommas = sep(amount, ',');
    const noDecCommas = sep(noDec, ',');
    const withCommaDecimal = amount.replace('.', ',').replace(/\B(?=(\d{3})+(?!\d),)/g, '.');
    const noDecDots = sep(noDec, '.');
    const withSpaces = sep(amount, ' ');
    const noDecSpaces = sep(noDec, ' ');
    const withApostrophes = sep(amount, "'");
    return format
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, noDecDots)
      .replace(/\{\{\s*amount_no_decimals_with_space_separator\s*\}\}/g, noDecSpaces)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withCommaDecimal)
      .replace(/\{\{\s*amount_with_space_separator\s*\}\}/g, withSpaces)
      .replace(/\{\{\s*amount_with_apostrophe_separator\s*\}\}/g, withApostrophes)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDecCommas)
      .replace(/\{\{\s*amount\s*\}\}/g, withCommas);
  };

  const swatchBackground = (swatch) => {
    if (!swatch) return '#ccc';
    if (swatch.indexOf('-') === -1) return swatch;
    const [a, b] = swatch.split('-');
    return `linear-gradient(135deg, ${a} 0%, ${b} 100%)`;
  };

  const productHandleFromUrl = (url) => {
    if (!url) return '';
    const m = url.match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : '';
  };

  const atcMarkup = (state, variantId, productUrl) => {
    if (state === 'sold-out') {
      return `<button class="detail-card-atc-link px-6 py-2.5 w-full text-white font-bold bg-black rounded shadow uppercase text-sm inline-flex justify-center items-center" type="button" disabled style="opacity:0.5;cursor:not-allowed;">${L.soldOut}</button>`;
    }
    if (state === 'unavailable') {
      const handle = productHandleFromUrl(productUrl);
      return `<button class="BIS_trigger detail-card-atc-link px-6 py-2.5 w-full text-white font-bold bg-black rounded shadow uppercase text-sm inline-flex justify-center items-center" data-bis data-product-handle="${handle}">${L.bisNotify}</button>`;
    }
    return `<button type="button" data-variant-id="${variantId}" class="detail-card-atc-link relative justify-center px-6 py-2.5 w-full text-white font-bold bg-black rounded shadow uppercase text-sm inline-flex items-center" onclick="atcCard(this)"><span class="add-to-cart-text">${L.addToCart}</span><span aria-hidden="true" class="add-to-cart-text--added">${ATC_CHECK_SVG}${L.added}</span></button>`;
  };

  const atcState = (available, discontinued) => {
    if (!available && discontinued) return 'sold-out';
    if (!available) return 'unavailable';
    return 'available';
  };

  const renderBadge = (container, type, mobile = false) => {
    container.innerHTML = '';
    const cfg = BADGES[type];
    if (!cfg) return;
    const el = document.createElement('span');

    if (cfg.icon) {
      el.className = mobile
        ? 'product-card-badge inline-flex px-[8px] py-[5px] rounded-full items-center'
        : 'product-card-badge px-1.5 py-1 md:px-2.5 md:py-1.5 rounded-full flex items-center';
      el.style.background = cfg.bg;
      if (cfg.border) el.style.border = cfg.border;
      const tpl = document.querySelector(`[data-badge-icon="${type}"]`);
      if (tpl) {
        el.innerHTML = tpl.innerHTML;
        if (mobile) {
          const svg = el.querySelector('svg');
          const vb = svg && svg.getAttribute('viewBox');
          if (vb) {
            const [, , w, h] = vb.split(/\s+/).map(parseFloat);
            svg.setAttribute('height', '12');
            svg.setAttribute('width', String(Math.round(12 * w / h)));
          }
        }
      }
    } else {
      el.className = mobile
        ? 'product-card-badge leading-none inline-block px-[8px] py-[5px] rounded-full text-[10px] font-semibold uppercase'
        : 'product-card-badge px-2 py-1 md:px-3 md:py-1.5 rounded-full text-[10px] md:text-xs font-semibold uppercase';
      el.style.background = cfg.bg;
      el.style.color = cfg.color;
      el.textContent = cfg.text;
    }
    container.appendChild(el);
  };

  const priceMarkup = (price, comparePrice) => {
    if (comparePrice > price && comparePrice > 0) {
      const pct = Math.round((comparePrice - price) / comparePrice * 100);
      return `<span class="line-through font-normal" style="color: var(--color-foreground-muted);">${formatMoney(comparePrice)}</span>` +
        `<span style="color: var(--color-foreground-heading);">${formatMoney(price)}</span>` +
        `<span class="font-bold" style="background: linear-gradient(284deg, #F05223 7.5%, #F51C82 92.5%); -webkit-background-clip: text; background-clip: text; color: transparent;">-${pct}%</span>`;
    }
    return formatMoney(price);
  };

  const ratingMarkup = (rating, count, max, key) => {
    if (!(rating > 0 && count > 0)) return null;
    const filled = Math.floor(rating);
    const dec = rating - filled;
    const fillPct = Math.round(dec * 100);
    const id = `dyn-${Date.now()}-${key}`;
    let stars = '';
    for (let s = 1; s <= max; s++) {
      let fill;
      if (s <= filled) fill = 'fill: var(--star-fill-color);';
      else if (s === filled + 1 && dec > 0) fill = `fill: url(#partial-${id});`;
      else fill = 'fill: rgb(var(--star-fill-color-rgb) / var(--opacity-20));';
      stars += `<svg class="stars" viewBox="0 0 32 32" style="height: var(--star-size); ${fill}" role="presentation">${STAR_PATH}</svg>`;
    }
    const grad = dec > 0
      ? `<svg style="width:0;height:0;position:absolute;"><defs><linearGradient id="partial-${id}" x1="0" x2="100%" y1="0" y2="0"><stop offset="${fillPct}%" stop-color="var(--star-fill-color)"/><stop offset="${fillPct}%" stop-color="rgb(var(--star-fill-color-rgb) / var(--opacity-20))"/></linearGradient></defs></svg>`
      : '';
    return grad +
      `<div class="rating" role="img" style="--star-size: calc(0.875rem * 1.1); display: flex; align-items: center; gap: 2px;">${stars}</div>` +
      `<p class="rating-count" style="font-size: 0.875rem; margin: 0;">(${count})</p>`;
  };

  const hoverDescriptionMarkup = (desc, url) =>
    `<span>${desc}</span>` +
    `<span class="absolute bottom-0 right-0 leading-[1.6]" style="background: linear-gradient(to right, transparent, white 25%); padding-left: 55px;">` +
    `<a href="${url}" class="text-[13px] font-bold whitespace-nowrap" style="color: var(--color-foreground-heading);">... ${L.moreDetails}</a></span>`;

  const syncHoverCard = (wrapper, slide, index, fallbackUrl, fallbackVariantId) => {
    if (!wrapper || !slide) return;
    const d = slide.dataset;
    const url = d.variantUrl || fallbackUrl;
    const variantId = d.variantId || fallbackVariantId || '';
    const price = parseInt(d.variantPrice) || 0;
    const compare = parseInt(d.variantComparePrice) || 0;
    const rating = parseFloat(d.variantRating) || 0;
    const ratingCount = parseInt(d.variantRatingCount) || 0;
    const ratingMax = parseInt(d.variantRatingMax) || 5;
    const available = d.variantAvailable === 'true';
    const discontinued = d.variantDiscontinued === 'true';

    const titleEl = wrapper.querySelector('.detail-card-title');
    if (titleEl) {
      titleEl.textContent = d.variantTitle || '';
      titleEl.href = url;
    }

    const linkEl = wrapper.querySelector('.detail-card-link');
    if (linkEl) linkEl.href = url;

    const priceEl = wrapper.querySelector('.detail-card-price');
    if (priceEl) priceEl.innerHTML = priceMarkup(price, compare);

    const descEl = wrapper.querySelector('[data-hover-description]');
    if (descEl && d.variantDescription) {
      descEl.innerHTML = hoverDescriptionMarkup(d.variantDescription, url);
    }

    const ratingEl = wrapper.querySelector('.product-card-v2-detail-card .rating-wrapper');
    if (ratingEl) {
      const html = ratingMarkup(rating, ratingCount, ratingMax, index);
      if (html) {
        ratingEl.innerHTML = html;
        ratingEl.style.display = '';
      } else {
        ratingEl.style.display = 'none';
      }
    }

    const atcEl = wrapper.querySelector('.product-card-v2-detail-card .detail-card-atc-link');
    if (atcEl && atcEl.parentElement) {
      atcEl.parentElement.innerHTML = atcMarkup(atcState(available, discontinued), variantId, url);
    }
  };

  class ProductCardV2 {
    constructor(card) {
      this.card = card;
      this.swiperContainer = card.querySelector('.product-card-image-swiper');
      this.wrapper = card.closest('.product-card-v2-wrapper');
      this.initialSlide = this.swiperContainer ? parseInt(this.swiperContainer.dataset.initialSlide) || 0 : 0;
      this.swatchButtons = card.querySelectorAll('.product-card-swatch');
      this.titleLink = card.querySelector('.product-card-title-link');
      this.priceLink = card.querySelector('.product-card-price-link');
      this.titleEl = card.querySelector('.product-card-title');
      this.badgeContainer = card.querySelector('.product-card-badge-container');
      this.mobileBadge = this.wrapper && this.wrapper.querySelector('.product-card-badge-mobile');
      this.swiper = null;
      this.hoverSwiper = null;
    }

    init() {
      if (!this.swiperContainer) return;

      this.swiper = new Swiper(this.swiperContainer, {
        initialSlide: this.initialSlide,
        slidesPerView: 1,
        spaceBetween: 0,
        loop: false,
        touchRatio: 1,
        threshold: 5,
        observer: true,
        observeParents: true,
        resizeObserver: true,
        on: {
          slideChange: (s) => this.onSlideChange(s),
        },
      });

      this.swatchButtons.forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          const idx = parseInt(btn.dataset.slideIndex);
          if (!isNaN(idx)) this.swiper.slideTo(idx);
        });
      });

      if (this.wrapper) {
        const imageContainer = this.wrapper.querySelector('.product-card-image-container');
        const detailCard = this.wrapper.querySelector('.product-card-v2-detail-card');
        const ensure = () => this.ensureHoverSwiper();
        if (imageContainer) {
          imageContainer.addEventListener('mouseenter', ensure);
          imageContainer.addEventListener('pointerenter', ensure);
          imageContainer.addEventListener('touchstart', ensure, { passive: true });
        }
        if (detailCard) {
          detailCard.addEventListener('mouseenter', ensure);
          detailCard.addEventListener('pointerenter', ensure);
          detailCard.addEventListener('touchstart', ensure, { passive: true });
        }
        if (imageContainer && imageContainer.matches(':hover')) ensure();
      }

      this.card.dataset.initialized = 'true';
    }

    ensureHoverSwiper() {
      if (this.hoverSwiper || !this.wrapper) return;
      const hoverEl = this.wrapper.querySelector('.detail-card-swiper');
      if (!hoverEl) return;

      const paginationEl = hoverEl.querySelector('.detail-card-pagination');
      if (paginationEl) {
        paginationEl.addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); });
      }
      const hoverSlides = hoverEl.querySelectorAll('.swiper-slide');

      this.hoverSwiper = new Swiper(hoverEl, {
        initialSlide: this.initialSlide,
        slidesPerView: 1,
        spaceBetween: 0,
        loop: false,
        pagination: {
          el: paginationEl,
          clickable: true,
          renderBullet: (index, className) => {
            const swatch = (hoverSlides[index] && hoverSlides[index].dataset.swatch) || '';
            return `<span class="${className}" style="background: ${swatchBackground(swatch)};"></span>`;
          },
        },
        on: {
          slideChange: (s) => {
            if (this.swiper && this.swiper.activeIndex !== s.activeIndex) {
              this.swiper.slideTo(s.activeIndex);
            }
          },
        },
      });
    }

    onSlideChange(swiper) {
      const idx = swiper.activeIndex;
      const slide = swiper.slides[idx];

      this.swatchButtons.forEach((btn, i) => {
        const active = i === idx;
        btn.classList.toggle('ring-1', active);
        btn.classList.toggle('ring-black', active);
        btn.classList.toggle('ring-offset-1', active);
      });

      if (this.hoverSwiper && this.hoverSwiper.activeIndex !== idx) {
        this.hoverSwiper.slideTo(idx);
      }

      if (!slide) return;

      const d = slide.dataset;
      const url = d.productUrl;
      const variantId = d.variantId || '';
      const available = d.available === 'true';
      const discontinued = d.discontinued === 'true';

      if (url && this.titleLink) this.titleLink.href = url;
      if (url && this.priceLink) this.priceLink.href = url;
      if (d.variantTitle && this.titleEl) this.titleEl.textContent = d.variantTitle;

      const atcEl = this.card.querySelector('.detail-card-atc-link');
      if (atcEl && atcEl.parentElement) {
        atcEl.parentElement.innerHTML = atcMarkup(atcState(available, discontinued), variantId, url);
      }

      const badgeType = d.badge ? d.badge.trim().toLowerCase() : '';
      if (this.badgeContainer) {
        this.badgeContainer.className = 'product-card-badge-container hidden md:!block z-50 flex';
        renderBadge(this.badgeContainer, badgeType);
      }
      if (this.mobileBadge) renderBadge(this.mobileBadge, badgeType, true);

      if (this.wrapper) {
        const hoverSlides = this.wrapper.querySelectorAll('.detail-card-swiper .swiper-slide');
        if (hoverSlides[idx]) syncHoverCard(this.wrapper, hoverSlides[idx], idx, url, variantId);
      }
    }
  }

  const initAll = () => {
    if (typeof Swiper === 'undefined') {
      setTimeout(initAll, 100);
      return;
    }
    document
      .querySelectorAll('.product-card-swiper[data-initialized="false"]')
      .forEach((card) => {
        try {
          new ProductCardV2(card).init();
        } catch (err) {
          console.warn('[product-card-v2] init failed for card', card, err);
          card.dataset.initialized = 'failed';
        }
      });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('click', (e) => {
    const bisBtn = e.target.closest('.product-card-v2-wrapper .BIS_trigger, .product-card-v2-detail-card .BIS_trigger');
    if (!bisBtn || bisBtn.dataset.productData) return;
    const handle = bisBtn.dataset.productHandle;
    if (!handle) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    fetch(`/products/${handle}.js`, { credentials: 'same-origin' })
      .then((r) => r.json())
      .then((product) => {
        bisBtn.setAttribute('data-product-data', JSON.stringify(product));
        bisBtn.click();
      })
      .catch((err) => console.warn('[product-card-v2] BIS product fetch failed', err));
  }, true);

  let initTimer = null;
  new MutationObserver((mutations) => {
    let found = false;
    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (node.nodeType !== 1) continue;
        if (
          (node.classList && node.classList.contains('product-card-swiper')) ||
          (node.querySelector && node.querySelector('.product-card-swiper[data-initialized="false"]'))
        ) {
          found = true;
          break;
        }
      }
      if (found) break;
    }
    if (found) {
      clearTimeout(initTimer);
      initTimer = setTimeout(initAll, 300);
    }
  }).observe(document.body, { childList: true, subtree: true });
})();

(() => {
  if (window.__bisModalFixActive) return;
  window.__bisModalFixActive = true;

  const closeBisModal = () => {
    const frame = document.getElementById('BIS_frame');
    if (frame) frame.style.display = 'none';
    document.body.style.overflow = '';
  };

  const attachIframeCloseHandler = () => {
    const frame = document.getElementById('BIS_frame');
    if (!frame || frame.__bisCloseAttached) return;
    try {
      const doc = frame.contentDocument || frame.contentWindow.document;
      if (!doc || !doc.getElementById('BISModal')) return;
      frame.__bisCloseAttached = true;
      doc.addEventListener('click', (e) => {
        if (e.target.closest('.action-close, [data-bs-dismiss="modal"]')) {
          setTimeout(closeBisModal, 10);
        }
      }, true);
    } catch (_) {}
  };

  document.addEventListener('click', (e) => {
    if (!e.target.closest('[data-bis]')) return;
    const frame = document.getElementById('BIS_frame');
    if (frame) frame.__bisCloseAttached = false;
    [300, 600, 1000, 2000].forEach((d) => setTimeout(attachIframeCloseHandler, d));
  });

  const pollId = setInterval(() => {
    const frame = document.getElementById('BIS_frame');
    if (frame && frame.__bisCloseAttached) { clearInterval(pollId); return; }
    attachIframeCloseHandler();
  }, 500);
  setTimeout(() => clearInterval(pollId), 30000);
})();
